export default {
  common: {
    appName: 'ElderCare',
    loading: 'Caricamento...',
    retry: 'Riprova',
    goBack: 'Home',
    logout: 'Esci',
    save: 'Salva',
    cancel: 'Annulla',
    confirm: 'Conferma',
    delete: 'Elimina',
    edit: 'Modifica',
    search: 'Cerca',
    weekDays: {
      sun: 'Dom',
      mon: 'Lun',
      tue: 'Mar',
      wed: 'Mer',
      thu: 'Gio',
      fri: 'Ven',
      sat: 'Sab',
    },
  },
  nav: {
    home: 'Home',
    login: 'Accedi',
    dashboard: 'Cruscotto',
    health: 'Salute',
    medication: 'Farmaci',
    sos: 'Emergenza',
    family: 'Famiglia',
    article: 'Articoli',
    checkin: 'Check-in',
    settings: 'Impostazioni',
    about: 'Info',
  },
  footer: {
    rights: 'Tutti i diritti riservati',
    privacy: 'Informativa sulla privacy',
    terms: 'Termini di servizio',
  },
  index: {
    hero: {
      title: 'ElderCare - Custode intelligente della salute per anziani',
      subtitle: 'Piattaforma di gestione della salute progettata per gli anziani, per mantenere le famiglie informate e gli anziani in salute',
      cta: 'Inizia',
      learnMore: 'Scopri di più',
    },
    features: {
      title: 'Funzionalità principali',
      health: { title: 'Monitoraggio salute', desc: 'Registra pressione arteriosa, glicemia e battito cardiaco con avvisi intelligenti' },
      medication: { title: 'Gestione farmaci', desc: 'Promemoria e controllo interazioni farmacologiche, non dimenticare mai una dose' },
      sos: { title: 'Chiamata di emergenza', desc: 'SOS con un tocco, notifica automatica alla famiglia e condivisione posizione' },
      family: { title: 'Cura familiare', desc: 'Monitoraggio a distanza, avvisi istantanei e condivisione dati per le famiglie' },
      article: { title: 'Articoli sulla salute', desc: 'Conoscenze sanitarie autorevoli e guide al benessere personalizzate' },
      checkin: { title: 'Check-in giornaliero', desc: 'Semplice tracciamento quotidiano per costruire abitudini sane' },
    },
    elderly: {
      title: 'Design per anziani',
      desc: 'Progettato per gli anziani: facile da usare, vedere e toccare',
      font: 'Caratteri grandi',
      touch: 'Aree touch ampie',
      contrast: 'Colori ad alto contrasto',
    },
  },
  login: {
    title: 'ElderCare',
    loginTab: 'Accedi',
    registerTab: 'Registrati',
    name: 'Nome',
    email: 'Email',
    password: 'Password',
    role: 'Sono',
    elderRole: 'Anziano',
    familyRole: 'Familiare',
    bindCode: 'Codice di collegamento',
    bindCodeHint: 'Inserisci il codice di collegamento dell\'account anziano per associare e visualizzare i dati sanitari',
    loginBtn: 'Accedi',
    registerBtn: 'Registrati',
    verifyHint: 'Dopo la registrazione verrà inviata un\'email di verifica al tuo indirizzo',
    error: 'Operazione fallita, riprova',
    nameTooShort: 'Il nome deve avere almeno 2 caratteri',
    emailInvalid: 'Inserisci un indirizzo email valido',
    passwordTooShort: 'La password deve avere almeno 8 caratteri',
  },
  dashboard: {
    title: 'Cruscotto salute',
    metrics: {
      bloodPressure: 'Pressione arteriosa',
      bloodSugar: 'Glicemia',
      heartRate: 'Battito cardiaco',
      weight: 'Peso',
      sleep: 'Sonno',
      temperature: 'Temperatura',
    },
    quickActions: 'Azioni rapide',
    recordHealth: 'Registra salute',
    takeMedicine: 'Prendi farmaco',
    sos: 'Chiamata emergenza',
    checkinStatus: 'Check-in di oggi',
    checkedIn: 'Registrato oggi',
    notCheckedIn: 'Non registrato oggi',
    goCheckin: 'Registrati',
    medicationReminders: 'Promemoria farmaci',
    noReminders: 'Nessun promemoria farmaci',
    taken: 'Preso',
  },
  health: {
    title: 'Cartella sanitaria',
    inputTitle: 'Inserimento dati',
    systolic: 'Sistolica (mmHg)',
    diastolic: 'Diastolica (mmHg)',
    bloodSugar: 'Glicemia (mmol/L)',
    heartRate: 'Battito cardiaco (bpm)',
    weight: 'Peso (kg)',
    sleepHours: 'Sonno (ore)',
    temperature: 'Temperatura (°C)',
    submit: 'Invia registrazione',
    trend: 'Tendenze',
    days: 'giorni',
    aiAnalysis: 'Analisi salute IA',
    analyze: 'Analizza',
    noAnalysis: 'Clicca sul pulsante sopra per ottenere un rapporto di analisi salute IA',
    history: 'Storico',
    noHistory: 'Nessuno storico',
    chartLabelSystolic: 'Pressione sistolica',
    atLeastOneField: 'Compila almeno un dato sanitario',
  },
  medication: {
    title: 'Gestione farmaci',
    currentPlan: 'Piano attuale',
    noMedications: 'Nessun farmaco',
    addMedication: 'Aggiungi farmaco',
    name: 'Nome farmaco',
    dosage: 'Dosaggio',
    frequency: 'Frequenza',
    freqDaily: 'Una volta al giorno',
    freqTwice: 'Due volte al giorno',
    freqThree: 'Tre volte al giorno',
    freqWeekly: 'Una volta a settimana',
    time: 'Orario assunzione',
    startDate: 'Data inizio',
    addBtn: 'Aggiungi',
    interactionWarning: 'Avviso interazione farmacologica',
    noInteraction: 'Nessun rischio di interazione farmacologica',
    calendar: 'Calendario farmaci',
  },
  sos: {
    title: 'Chiamata di emergenza',
    holdToCall: 'Tieni premuto per chiamare',
    holdHint: 'Tieni premuto 1 secondo per attivare la chiamata di emergenza',
    sent: 'Chiamata di emergenza inviata',
    sentDesc: 'I tuoi contatti di emergenza sono stati notificati. Resta calmo e aspetta aiuto',
    contacts: 'Contatti di emergenza',
    location: 'Posizione attuale',
    loadingLocation: 'Localizzazione in corso...',
    locationUnavailable: 'Posizione non disponibile',
    history: 'Storico SOS',
    noHistory: 'Nessun registro SOS',
    confirmed: 'Confermato',
    pending: 'In attesa',
  },
  family: {
    title: 'Cura familiare',
    members: 'Famiglia collegata',
    noMembers: 'Nessun familiare collegato',
    bindCode: 'Codice di collegamento',
    bindCodeHint: 'Condividi questo codice con i familiari per collegare gli account',
    invite: 'Invita familiare',
    email: 'Email familiare',
    relationship: 'Relazione',
    relSon: 'Figlio',
    relDaughter: 'Figlia',
    relSpouse: 'Coniuge',
    relSibling: 'Fratello/Sorella',
    relOther: 'Altro',
    inviteBtn: 'Invia invito',
    notifications: 'Preferenze notifiche',
    prefAbnormal: 'Avviso anomalia sanitaria',
    prefMedication: 'Promemoria farmaci',
    prefSos: 'Avviso emergenza',
    prefWeekly: 'Report settimanale',
    prefCheckin: 'Notifica check-in',
    dataSharing: 'Condivisione dati',
    shareDesc: 'Consenti alla famiglia di visualizzare i tuoi dati sanitari',
  },
  article: {
    title: 'Articoli sulla salute',
    search: 'Cerca articoli...',
    noArticles: 'Nessun articolo trovato',
    expand: 'Leggi di più',
    collapse: 'Comprimi',
    categories: {
      all: 'Tutti',
      heart: 'Apparato cardiovascolare',
      diabetes: 'Diabete',
      bone: 'Ossa',
      sleep: 'Sonno',
      nutrition: 'Nutrizione',
      exercise: 'Esercizio',
    },
  },
  checkin: {
    title: 'Check-in giornaliero',
    feeling: 'Come ti senti oggi?',
    feelings: {
      great: 'Ottimo',
      good: 'Bene',
      normal: 'Normale',
      bad: 'Male',
      terrible: 'Malissimo',
    },
    medication: 'Farmaci oggi',
    yes: 'Sì',
    no: 'No',
    diet: 'Valutazione dieta',
    dietRatings: {
      good: 'Buona',
      normal: 'Normale',
      poor: 'Scarsa',
    },
    exercise: 'Esercizio oggi',
    mood: 'Umore',
    submit: 'Invia check-in',
    streak: 'Serie',
    streakDays: 'giorni',
    calendar: 'Calendario check-in',
  },
  settings: {
    title: 'Impostazioni',
    profile: 'Profilo',
    name: 'Nome utente',
    phone: 'Telefono',
    birthday: 'Data di nascita',
    emergencyContact: 'Contatto di emergenza',
    save: 'Salva modifiche',
    preferences: 'Preferenze',
    language: 'Lingua',
    theme: 'Tema',
    light: 'Chiaro',
    dark: 'Scuro',
    notifications: 'Notifiche',
    notifHealth: 'Avvisi salute',
    notifMedication: 'Promemoria farmaci',
    notifSos: 'Avvisi emergenza',
    notifCheckin: 'Promemoria check-in',
    bindCode: 'Il mio codice',
    changePassword: 'Cambia password',
    currentPassword: 'Password attuale',
    newPassword: 'Nuova password',
    changePasswordBtn: 'Cambia password',
    dangerZone: 'Zona pericolosa',
    deleteDesc: 'L\'eliminazione dell\'account è irreversibile. Tutti i dati saranno persi',
    deleteAccount: 'Elimina account',
    deleteConfirm: 'Sei sicuro? Questa azione è irreversibile!',
  },
  about: {
    title: 'Info su ElderCare',
    subtitle: 'Custode intelligente della salute per anziani',
    intro: 'Introduzione',
    introContent: 'ElderCare è una piattaforma di gestione della salute progettata per gli anziani, con monitoraggio intelligente, gestione dei farmaci, chiamate di emergenza e molto altro, per aiutare gli anziani a gestire la propria salute rimanendo connessi con la famiglia.',
    version: 'Informazioni versione',
    versionNumber: 'Numero di versione',
    buildDate: 'Data di compilazione',
    acknowledgements: 'Ringraziamenti',
    contact: 'Contatto',
    contactEmail: "q3300404157{'@'}gmail.com",
    privacy: 'Informativa sulla privacy',
    terms: 'Termini di servizio',
  },
  notfound: {
    message: 'Spiacenti, la pagina che stai cercando non esiste',
    goHome: 'Torna alla home',
  },
  privacy: {
    title: 'Informativa sulla privacy',
    sections: {
      collection: {
        title: 'Raccolta delle informazioni',
        content: 'Raccogliamo solo le informazioni personali necessarie per fornire i servizi, inclusi i dati di registrazione (email, nome), i dati sanitari (pressione arteriosa, glicemia e altri parametri) e le informazioni sul dispositivo. Non raccogliamo informazioni personali non correlate ai nostri servizi.',
      },
      usage: {
        title: 'Utilizzo delle informazioni',
        content: 'Le tue informazioni personali sono utilizzate esclusivamente per fornire e migliorare i servizi, tra cui analisi dei dati sanitari, avvisi di anomalie, promemoria farmaci e altre funzionalità essenziali. Non utilizzeremo le tue informazioni per scopi non autorizzati.',
      },
      storage: {
        title: 'Archiviazione delle informazioni',
        content: 'I tuoi dati sono archiviati su server cloud sicuri con trasmissione e archiviazione cifrate. Adottiamo misure tecniche ragionevoli per proteggere la sicurezza dei tuoi dati e prevenire accessi non autorizzati.',
      },
      sharing: {
        title: 'Condivisione delle informazioni',
        content: 'Senza il tuo consenso esplicito, non condivideremo le tue informazioni personali con terze parti. I dati sanitari saranno condivisi con i familiari collegati solo dopo la tua autorizzazione alla connessione familiare.',
      },
      rights: {
        title: 'I tuoi diritti',
        content: 'Hai il diritto di accedere, correggere ed eliminare le tue informazioni personali, nonché di revocare il tuo consenso. Puoi esercitare questi diritti tramite le impostazioni dell\'app o contattando il nostro team di assistenza.',
      },
      security: {
        title: 'Sicurezza',
        content: 'Utilizziamo crittografia e misure di sicurezza conformi agli standard di settore per proteggere i tuoi dati, tra cui trasmissione cifrata SSL, archiviazione cifrata dei dati e controllo degli accessi. Rivediamo e aggiorniamo regolarmente le nostre misure di sicurezza.',
      },
    },
  },
  terms: {
    title: 'Termini di servizio',
    sections: {
      acceptance: {
        title: 'Accettazione dei termini',
        content: 'Utilizzando questa applicazione, accetti di conformarti ai presenti termini di servizio. Se non sei d\'accordo con una qualsiasi parte di questi termini, ti preghiamo di cessare l\'uso dell\'applicazione. Ci riserviamo il diritto di modificare questi termini in qualsiasi momento.',
      },
      service: {
        title: 'Descrizione del servizio',
        content: 'ElderCare fornisce servizi di assistenza alla gestione della salute, tra cui registrazione dei dati sanitari, promemoria farmaci, chiamate di emergenza e altre funzionalità. Questo servizio è solo a scopo informativo e non costituisce parere medico, né può sostituire servizi medici professionali.',
      },
      accounts: {
        title: 'Gestione account',
        content: 'È necessario registrare un account per utilizzare le funzionalità essenziali di questa applicazione. Sei responsabile della sicurezza della tua password e di tutte le attività effettuate con il tuo account. Se rilevi un uso non autorizzato del tuo account, ti preghiamo di notificarcelo immediatamente.',
      },
      data: {
        title: 'Dati e privacy',
        content: 'Diamo grande importanza alla protezione della tua privacy. Per le regole dettagliate sul trattamento dei dati, consulta la nostra Informativa sulla privacy. Mantieni il pieno controllo sui dati sanitari che invii.',
      },
      liability: {
        title: 'Limitazione di responsabilità',
        content: 'Le informazioni sanitarie fornite da questa applicazione sono solo a scopo informativo e non costituiscono diagnosi o consigli di trattamento medico. Non siamo responsabili per eventuali perdite derivanti dall\'uso delle informazioni di questa applicazione. In caso di problemi di salute, consulta un professionista sanitario qualificato.',
      },
      changes: {
        title: 'Modifiche ai termini',
        content: 'Potremmo aggiornare questi termini di servizio periodicamente. Le modifiche significative ti saranno comunicate tramite notifiche nell\'app o via email. L\'uso continuato di questa applicazione costituisce l\'accettazione dei termini aggiornati.',
      },
    },
  },
  feedback: {
    title: 'Feedback',
    subtitle: 'Il tuo feedback è molto importante per noi',
    name: 'Nome',
    namePlaceholder: 'Inserisci il tuo nome (opzionale)',
    email: 'E-mail',
    emailPlaceholder: 'Inserisci la tua e-mail',
    subject: 'Argomento',
    subjectGeneral: 'Feedback generale',
    subjectBug: 'Segnalazione bug',
    subjectFeature: 'Suggerimento funzionalità',
    subjectOther: 'Altro',
    message: 'Messaggio',
    messagePlaceholder: 'Descrivi il tuo feedback in dettaglio...',
    submit: 'Invia feedback',
    submitting: 'Invio in corso...',
    success: 'Feedback inviato con successo! Grazie per il tuo contributo',
    error: 'Invio fallito, riprova più tardi',
  },
  verify: {
    loading: 'Verifica della tua e-mail in corso...',
    success: 'Verifica completata!',
    successDesc: 'La tua e-mail è stata verificata. Ora puoi accedere',
    failed: 'Verifica fallita',
    failedDesc: 'Il link di verifica non è valido o è scaduto. Invia di nuovo l\'e-mail di verifica',
    resend: 'Invia di nuovo e-mail di verifica',
    resending: 'Invio in corso...',
    goLogin: 'Vai al login',
  },
  theme: {
    light: 'Chiaro',
    dark: 'Scuro',
  },
}
